import { useState, useRef, useCallback } from 'react';
import '../styles/app/forms.css';

const THRESHOLD = 80;
const MAX_PULL = 120;

function PullToRefresh({ onRefresh, children }) {
  const [pulling, setPulling] = useState(false);
  const [pullDistance, setPullDistance] = useState(0);
  const [refreshing, setRefreshing] = useState(false);
  const startY = useRef(0);
  const containerRef = useRef(null);

  const handleTouchStart = useCallback((e) => {
    if (window.scrollY === 0 && !refreshing) {
      startY.current = e.touches[0].clientY;
      setPulling(true);
    }
  }, [refreshing]);

  const handleTouchMove = useCallback((e) => {
    if (!pulling || refreshing) return;
    const diff = e.touches[0].clientY - startY.current;
    if (diff > 0) {
      const distance = Math.min(diff * 0.5, MAX_PULL);
      setPullDistance(distance);
    }
  }, [pulling, refreshing]);

  const handleTouchEnd = useCallback(async () => {
    if (!pulling) return;
    if (pullDistance >= THRESHOLD && onRefresh) {
      setRefreshing(true);
      try {
        await onRefresh();
      } catch (e) { /* silent */ }
      setRefreshing(false);
    }
    setPulling(false);
    setPullDistance(0);
  }, [pulling, pullDistance, onRefresh]);

  const progress = Math.min(pullDistance / THRESHOLD, 1);
  const showIndicator = pullDistance > 10 || refreshing;

  return (
    <div
      ref={containerRef}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      {showIndicator && (
        <div
          className="pnp-sys-ptr"
          style={{
            height: refreshing ? '50px' : `${pullDistance}px`,
            transition: pulling ? 'none' : 'height 0.2s ease'
          }}
        >
          <div
            className={`pnp-sys-ptr-octa${refreshing ? ' is-refreshing' : ''}`}
            style={{
              opacity: refreshing ? 1 : progress,
              transform: refreshing ? undefined : `rotate(${pullDistance * 3}deg) scale(${0.7 + progress * 0.3})`,
            }}
            aria-hidden="true"
          >
            <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="3" strokeLinejoin="round">
              <path d="M11 3h10l8 8v10l-8 8H11l-8-8V11z" opacity="0.25" />
              <path d="M11 3h10l8 8v10" strokeLinecap="round" />
            </svg>
          </div>
        </div>
      )}
      {children}
    </div>
  );
}

export default PullToRefresh;
